function getStatusBsStyle(status) {
    const styles = {
        'DRAFT': 'warning',
        'NEEDS_REVISION': 'danger',
        'DELETED': 'default',
        'SUBMITTED': 'info',
        'PUBLISHED': 'success'
    }
    return styles[status] || 'default';
}

function getStatusDisplayString(status) {
    return status.replace(/_/g, ' ');
}

export {
    getStatusBsStyle,
    getStatusDisplayString
}
